import React, { useState, useEffect, useContext } from "react";
import SupplierLocationReadOnlyRow from "./SupplierLocationReadOnlyRow";
import SupplierLocationTableRow from "./SupplierLocationTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";

function SupplierLocationTable({ key, setLocation, partner, supplierCompanyId, resetMenu }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [error, setError] = useState("");
    const [isCompanyLocationLoading, setIsCompanyLocationLoading] = useState(false);
    const [isPartnerLocationLoading, setIsPartnerLocationLoading] = useState(false);
    const [isSupplierDateLoading, setIsSupplierDateLoading] = useState(false);
    const [companyLocationList, setCompanyLocationList] = useState([]);
    const [partnerLocations, setPartnerLocations] = useState([]);
    const [supplierDates, setSupplierDates] = useState([]);
    const [count, setCount] = useState(key);
    const closeText = t("page.close");
    const userCtx = useContext(UserContext);

    const initialValues = {
        partnershipKey: partner.partnershipKey,
        supplierCompanyId: supplierCompanyId,
        clientCompanyId: partner.clientCompanyId,
        locationKey: 0,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
    useEffect(() => {
        fetchCompanyLocations();
        fetchPartnerLocations();
        fetchSupplierDates();
    }, []);

    const handleClose = (event) => {
        setLocation(false);
        if (resetMenu) {
            resetMenu();
        }
    };

    function fetchCompanyLocations() {
        setError("");
        if (!supplierCompanyId || supplierCompanyId === 0) {
            return;
        }

        setIsCompanyLocationLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                companyId: supplierCompanyId, getWaterSources: false, getWaterEquipClean: false
            }),
        };
        try {
            FetchUtil.fetchAPI("GetWorkLocations", "/Service/CompanyService/GetWorkLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
        } catch (error) {
            setIsCompanyLocationLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveWorkLocationFail(redirect) {
        setIsCompanyLocationLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.locNotRetrieved"));
    }

    function retrieveWorkLocationSuccess(responseData) {
        let fetchWorkLocationsResponse;
        if (responseData) {
            fetchWorkLocationsResponse = responseData.fetchWorkLocationsResponse;
            if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "0") {
                setCompanyLocationList(fetchWorkLocationsResponse.locations.slice());
            } else if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchWorkLocationsResponse) {
                setError(t("error.error") + " " + fetchWorkLocationsResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsCompanyLocationLoading(false);
    }

    function fetchPartnerLocations() {
        setError("");
        if (!initialValues.supplierCompanyId || initialValues.supplierCompanyId === 0
            || !initialValues.clientCompanyId || initialValues.clientCompanyId === 0) {
            return;
        }
        resetCounter();
        setIsPartnerLocationLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true, supplierKey: initialValues.supplierCompanyId,
                buyerKey: initialValues.clientCompanyId, userCompanyId: userCompanyId,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerLocations", "/Service/CompanyService/GetPartnerLocations", requestOptions, retrievePartnerLocationSuccess, retrievePartnerLocationFail);
        } catch (error) {
            setIsPartnerLocationLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerLocationFail(redirect) {
        setIsPartnerLocationLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.locNotRetrieved"));
    }

    function retrievePartnerLocationSuccess(responseData) {
        let getPartnerLocationResponse;
        if (responseData) {
            getPartnerLocationResponse = responseData.getPartnerLocationResponse;
            if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "0") {
                setPartnerLocations(getPartnerLocationResponse.locations.slice())
            } else if (getPartnerLocationResponse && getPartnerLocationResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerLocationResponse) {
                setError(t("error.error") + " " + getPartnerLocationResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsPartnerLocationLoading(false);
    }
    function fetchSupplierDates() {
        setError("");
        if (!initialValues.supplierCompanyId || initialValues.supplierCompanyId === 0
            || !initialValues.partnershipKey || initialValues.partnershipKey === 0
            || !initialValues.clientCompanyId || initialValues.clientCompanyId === 0) {
            return;
        }
        resetCounter();
        setSupplierDates([]);
        setIsSupplierDateLoading(true);
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false, supplierKey: initialValues.supplierCompanyId,
                partnershipKey: initialValues.partnershipKey, buyerKey: initialValues.clientCompanyId,
                userCompanyId: userCompanyId,
                includeInactivePartner: true
            }),
        };
        try {
            FetchUtil.fetchAPI("GetPartnerDates", "/Service/CompanyService/GetPartnerDates", requestOptions, retrievePartnerDateSuccess, retrievePartnerDateFail);
        } catch (error) {
            setIsPartnerSurveyLoading(false);
            throw new Error(error.message);
        }
    }

    function retrievePartnerDateFail(redirect) {
        setIsSupplierDateLoading(false);
        if (redirect) {
            navigate("/");
        }
        setError(t("error.partnerGetDateFailed"));
    }

    function retrievePartnerDateSuccess(responseData) {
        let getPartnerDatesResponse;
        if (responseData) {
            getPartnerDatesResponse = responseData.getPartnerDatesResponse;
            if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "0") {
                setSupplierDates(getPartnerDatesResponse.supplierDates.slice())
            } else if (getPartnerDatesResponse && getPartnerDatesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getPartnerDatesResponse) {
                setError(t("error.error") + " " + getPartnerDatesResponse.errorMessage);
            } else {
                setError(t("error.system.fetch"));
            }
        }
        setIsSupplierDateLoading(false);
    }

    const handleDeleteClick = (event, partnerLocationItem, completeCallback) => {
        event.preventDefault();
        deletePartnerLocation(partnerLocationItem, completeCallback);
    };
    const deletePartnerLocation = (partnerLocationItem, completeCallback) => {
        let action = 3;
        if (partnerLocationItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            supplierCompanyId: formValues.supplierCompanyId,
            clientCompanyId: formValues.clientCompanyId,
            partnershipKey: formValues.partnershipKey,
            locationKey: partnerLocationItem.locationKey,
            userCompanyId: userCompanyId,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeletePartnerLocation", "/Service/CompanyService/DeletePartnerLocation", requestOptions, deletePartnerLocationSuccess, deletePartnerLocationFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deletePartnerLocationFail(redirect, completeCallback) {
        setError(t("error.locEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deletePartnerLocationSuccess(responseData, completeCallback) {
        let deletePartnerLocationResponse;
        if (responseData) {
            deletePartnerLocationResponse = responseData.deletePartnerLocationResponse;
            if (deletePartnerLocationResponse) {
                if (deletePartnerLocationResponse.errorCode === "0") {
                    resetRowTable();
                    fetchPartnerLocations();
                } else {
                    setError(t("error.error") + " " +
                        deletePartnerLocationResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };
    const addRowTable = () => {
        setError("");
        if (!add) {
            setAdd(true);
        } else {
            setError(t("error.only1RowAllowed"));
        }

    };
    const removeRowTable = () => {
        setError("");
        resetRowTable();
    };
    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleSubmit = (action, setValues, completeCallback) => {
        setError("");
        let found = false;
        if (!formValues.supplierCompanyId || formValues.supplierCompanyId === 0
            || !formValues.clientCompanyId || formValues.clientCompanyId === 0) {
            setError(t("error.locEditFailed"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (partnerLocations.length > 0) {
                partnerLocations.map((partnerLocationItem, index) => {
                    if (partnerLocationItem.locationKey === setValues.locationKey) {
                        setError(t("error.locDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                savePartnerLocation(action, setValues, completeCallback);
            }
        } else if (action === 2) {
            if (partnerLocations.length > 0) {
                partnerLocations.map((partnerLocationItem, index) => {
                    if (partnerLocationItem.partnershipKey === formValues.partnershipKey &&
                        partnerLocationItem.locationKey === setValues.locationKey) {
                        found = true;
                    }
                })
            }
            if (found) {
                savePartnerLocation(action, setValues, completeCallback);
            } else {
                if (completeCallback) {
                    completeCallback();
                }
            }
        }
    };

    const savePartnerLocation = (action, setValues, completeCallback) => {
        let serverParams = {
            supplierCompanyId: formValues.supplierCompanyId,
            clientCompanyId: formValues.clientCompanyId,
            partnershipKey: formValues.partnershipKey,
            userCompanyId: userCompanyId,
            locationKey: setValues.locationKey,
            partnerNumber: setValues.partnerNumber,
            partnershipDateKeys: setValues.partnershipDateKeys,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdatePartnerLocation", "/Service/CompanyService/AddUpdatePartnerLocation", requestOptions, savePartnerLocationSuccess, savePartnerLocationFail, completeCallback);
        } catch (error) {
            setError(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function savePartnerLocationFail(redirect, completeCallback) {
        setError(t("error.locEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function savePartnerLocationSuccess(responseData, completeCallback) {
        let addUpdatePartnerLocationResponse;
        if (responseData) {
            addUpdatePartnerLocationResponse = responseData.addUpdatePartnerLocationResponse;
            if (addUpdatePartnerLocationResponse) {
                if (addUpdatePartnerLocationResponse.errorCode === "0") {
                    resetRowTable();
                    fetchPartnerLocations();
                } else {
                    setError(t("error.error") + " " +
                        addUpdatePartnerLocationResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }


    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="container-fluid container_list_sm viewh-85">
                    <div className="row">
                        <div className="col mt-3">
                            {(error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                        {(isCompanyLocationLoading || isPartnerLocationLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.dept.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.loc.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.address")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.suplrNumber")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.dates.access")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "11vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <SupplierLocationTableRow
                                            key={count}
                                            companyLocationList={companyLocationList}
                                            supplierDates={supplierDates}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            setIsLocationLoading={setIsCompanyLocationLoading}
                                            oddIdx={((partnerLocations.length % 2) > 0) ? true : false} />
                                    }
                                    {(partnerLocations.length > 0) ? (
                                        partnerLocations.map((partnerLocationItem, index) => (
                                            <SupplierLocationReadOnlyRow
                                                key={count}
                                                t={t}
                                                supplierDates={supplierDates}
                                                partnerLocationItem={partnerLocationItem}
                                                handleSubmit={handleSubmit}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                add={add}
                                                setError={setError}
                                            />
                                        ))
                                    ) : (<></>)}
                                    {add && addRowBottom &&
                                        <SupplierLocationTableRow
                                            key={count}
                                            companyLocationList={companyLocationList}
                                            supplierDates={supplierDates}
                                            handleSubmit={handleSubmit}
                                            setError={setError}
                                            t={t}
                                            setAdd={setAdd}
                                            setIsLocationLoading={setIsCompanyLocationLoading}
                                            oddIdx={((partnerLocations.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(partnerLocations.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.dept.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.loc.name")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.address")}</th>
                                        <th className="list-th" style={{ maxWidth: "15vw" }}>{t("page.suplrNumber")}</th>
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.dates.access")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "11vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                            <div className="row">
                                <div className="col mt-3">
                                    {(error) ? (
                                        <div id="inerrorMessage1" className="errorblock">
                                            {error}
                                        </div>
                                    ) : (<></>)}
                                </div>
                            </div>
                            <div className="footer">
                                <input
                                    type="button"
                                    name="edit-comp-loc-close"
                                    id="edit-comp-loc-close"
                                    className="btn btn-secondary btn-block" data-dismiss="modal"
                                    onClick={(e) => handleClose(e)}
                                    style={{ marginTop: "10px", marginBottom: "10px" }}
                                    value={closeText}
                                ></input>
                            </div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}
export default SupplierLocationTable;